import { render, staticRenderFns } from "./Generic.vue?vue&type=template&id=68f9cdfd&"
import script from "./Generic.vue?vue&type=script&lang=js&"
export * from "./Generic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Generic.vue"
export default component.exports